import queryString from "query-string";
import React, { useState } from 'react';
import { setNewResetPassword, updateUserPassword } from '../api/auth';
import { resetPasswordExistingUserShape, resetPasswordShape, resetPasswordShapeWithName } from '../data/form-shapes';
import { validatePassword } from "../helpers/core";
import { ErrorMessage } from "./error-message";
import { CreateForm } from './form-components';

export const checkUserPassword = (password: string, password_two: string, setPageError?: (error: string[]) => void) => {
  let isValidPassword = false
  if (password && password_two) {
    const {isValid} = validatePassword(password)
    const isMatching = !!(password === password_two)
    if ( !isMatching || (isMatching && !isValid)) {
      if (setPageError) {
        const failedPasswordMessage = isValid ? [] : ['Your password must be at least **6 characters long** and **contain both letters and numbers**.']
        const matchingMessage = isMatching ? [] : ['Both passwords must be matching.']
        setPageError([...matchingMessage, ...failedPasswordMessage])
      }
    } else {
      if (setPageError) {
       setPageError([])
      }
      isValidPassword = true
    }
  }
  
  return isValidPassword
}

interface ResetPasswordProps {
  onError?: ( err: string[]) => void;
  isNewUser?: boolean;
  onSuccess?: () => void;
  isModal?: boolean;
  onClose?: () => void;
}

export const ResetPassword = ({onError, isNewUser = false, onSuccess, isModal = false, onClose}: ResetPasswordProps) => {
  const [pageError, setPageError] = useState<string[]>([]);

  return ( <>
    <CreateForm
      showErrors={false}
      intro={isModal ? <ErrorMessage message={pageError} /> : null}
      shape={isNewUser ? resetPasswordShapeWithName : (isModal ? resetPasswordExistingUserShape : resetPasswordShape)}
      submitButtonLabel={isNewUser ? 'Create account' : (isModal ? 'Update' : 'Reset password') }
      title={isModal ? 'Update your password' : ''}
      oneButtonSubmit={!isModal}
      isModal={isModal}
      onCancel={() => {
        if (isModal && onClose) {
          onClose()
        }
      }}
      successMessage="Your password has been updated."
      defaultValues={null}
      onError={(err: string | null | undefined) => {
        const useMessage = (err === null || err === undefined) ? [] : [err]
        setPageError(useMessage)
        if (onError) {
          onError(useMessage)
        }
      }}
      onChange={(vals: any, key: string) => {
        const {password, password_two} = vals
        const isValid = checkUserPassword(password, password_two, (err: string[]) => {
          setPageError(err)
          if (onError) {
            onError(err)
          }
        })
      }}
      onSuccess={() => {
        if (onSuccess) {
          onSuccess()
        }
        // setShowMessage(true)
        // setLoading(false)
      }}
      onSubmit={(vals: any ) => {
        const {password, password_two} = vals
        const isValid = checkUserPassword(password, password_two, (err: string[]) => {
          setPageError(err)
          if (onError) {
            onError(err)
          }
        })
        if (!isValid) {
          const message = 'Incorrect password or passwords do not match.'
          return new Promise((resolve) => {
            resolve({
              error: 500,
              message,
              response: null,
            })
          })
        }
        
        if (isModal) {
          const {existing_password} = vals

          if (!existing_password) {
            const message = 'You must provide existing password.'
            return new Promise((resolve) => {
              resolve({
                error: 500,
                message,
                response: null,
              })
            })
          }

          const props = {
            password: password as string,
            existing_password: existing_password as string,
          }
          return updateUserPassword(props)
        }

        const q = queryString.parse(location.search);
        const { token } = q;
        const props = {
          password: password as string, 
          token: token as string, 
          first_name: '',
          last_name: '',
          job_title: '',
        }

        if (isNewUser) {
          const {first_name, last_name, job_title} = vals 
          props.first_name = first_name
          props.last_name = last_name
          props.job_title = job_title
        }
        return setNewResetPassword(props)
      }}
    />
  </>
  )
}